import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useNavigate} from 'react-router-dom';

import Modal from '../../../../../../components/mazraeKit/modal';

interface ISuccessRegisterModalProps {
  isSuccessModal: boolean;
  setIsSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  navigateLink?: string;
  modalText?: string;
  guid?: string;
}

const SuccessRegisterModal = ({
  setIsSuccessModal,
  isSuccessModal,
  navigateLink,
  guid,
  modalText,
}: ISuccessRegisterModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isSuccessModal} setIsOpen={setIsSuccessModal}>
      <div className="w-[320px] flex flex-col p-3 gap-3">
        <div className="flex items-center justify-between">
          <div className="flex w-[90%] justify-center">
            <SpanIcon className="icon-nameCheck-circle text-xxl  text-farm-shop-500" />
          </div>
          <button
            onClick={() => {
              setIsSuccessModal(false);
              guid && navigate('/my-ads');
            }}
          >
            <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
          </button>
        </div>
        <h5 className="w-full text-gray-950 flex justify-center">
          آگهی با موفقیت ثبت شد
        </h5>
        <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
          {modalText
            ? modalText
            : 'آگهی شما توسط کارشناسان مزرعه بررسی و سپس منتشر خواهد شد.'}
        </p>
        {!guid && (
          <button
            className="bg-farm-shop-500 text-white rounded h-10 w-full mt-1 text-regular text-sm"
            onClick={() =>
              navigate(navigateLink ? navigateLink : '/my-account')
            }
          >
            ورود به مدیریت آگهی
          </button>
        )}
      </div>
    </Modal>
  );
};

export default SuccessRegisterModal;
